import React from 'react';
import './App.css';
import sun from './img/sun-line.svg';
import moon from './img/moon-line.svg';

import Profile from './page/profile';
import About from './page/about';
import Skill from './page/skill';
import Footer from './page/footer';
import Client from './page/client';
import Services from './page/services';
import Portifolio from './page/portifolio';

function App() {
  const [darkMode, setDarkMode] = React.useState(false);

  React.useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
  }, [darkMode]);

  return (
    <>
      <header className="App-header">
        <nav>
          <ul id='ul'>
            <strong>AlfeuX</strong>
            <li> <a href='#about' rel='noreferrer noopener' > About </a> </li>
            <li> <a href='#skills' rel='noreferrer noopener' > Skills </a> </li>
            <li> <a href='#services' rel='noreferrer noopener' > Services </a> </li>
            <li> <a href='#portfolio' rel='noreferrer noopener' > Portfolio </a> </li>
            <li> <span> More &#9660; </span>
              <ul>
                <li> <a href='#clients' rel='noreferrer noopener' > Clients </a> </li>
              </ul>
            </li>
          </ul>

          <div id='daynight'>
            <input id='mode' type='checkbox' onChange={() => setDarkMode(!darkMode)}/>
            <label id='modeBtn' for='mode'> <span></span> <img src={sun} alt='Day' /> <img src={moon} alt='Night' /> </label>
          </div>

          <div id='menu'>
            <input type="checkbox" id="bt_menu" />
            <label for="bt_menu" id='menuBtn'> &#9776; </label>
            <div id='menuBox'>
              <ul>
                <li> <a href='#about' rel='noreferrer noopener' > About </a> </li>
                <li> <a href='#skills' rel='noreferrer noopener' > Skills </a> </li>
                <li> <a href='#services' rel='noreferrer noopener' > Services </a> </li>
                <li> <a href='#portifolio' rel='noreferrer noopener' > Portfolio </a> </li>
                <li> <a href='#events' rel='noreferrer noopener' > Events </a> </li>
                <li> <a href='#communities' rel='noreferrer noopener' > Communities </a> </li>
                <li> <a href='#clients' rel='noreferrer noopener' > Clients </a> </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>

      <section className='App-body'>
        <Profile/>
        <About/>
        <Skill/>
        <Services/>
        <Portifolio/>
        <br/>
        <br/>
        <Client/>
      </section>
      
      <Footer/>
    </>
  );
}

export default App;